import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Carousel } from "react-bootstrap";
import "./InsightResourceSec.css";

export default function InsightResourceSec({ currentLanguage = "en" }) {
  const isFrench = currentLanguage === "fr";

  // ================= ENGLISH DATA =================
  const dataEN = {
    subtitle: "INSIGHTS & RESOURCES",
    heading: "STAY AHEAD WITH EXPERT FINANCIAL PERSPECTIVES",
    cards: [
      {
        img: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=400",
        title: "The Changing Landscape of Global Finance",
        date: "20 Jan 2025",
        text:
          "Discover how shifting economic policies and technological innovation are redefining global markets and corporate financial strategies.",
      },
      {
        img: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=400",
        title: "Sustainable Growth: Beyond the Balance Sheet",
        date: "20 Jan 2025",
        text:
          "Understand how ESG integration is becoming a financial imperative for forward-thinking businesses and investors.",
      },
      {
        img: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=400",
        title: "Private Equity in a Post-Digital Era",
        date: "20 Jan 2025",
        text:
          "Learn how modern analytics and digital transformation are reshaping private equity deal-making and portfolio management.",
      },
      {
        img: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=400",
        title: "Navigating Tax Reforms in Emerging Markets",
        date: "20 Jan 2025",
        text:
          "A concise breakdown of how evolving tax frameworks across regions impact global business operations and compliance.",
      },
    ],
  };

  // ================= FRENCH DATA =================
  const dataFR = {
    subtitle: "ANALYSES & RESSOURCES",
    heading: "ANTICIPEZ AVEC DES PERSPECTIVES FINANCIÈRES D’EXPERTS",
    cards: [
      {
        img: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=400",
        title: "L’évolution du paysage financier mondial",
        date: "20 Jan 2025",
        text:
          "Découvrez comment les changements de politiques économiques et l’innovation technologique redéfinissent les marchés mondiaux et les stratégies financières.",
      },
      {
        img: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=400",
        title: "Croissance durable : au-delà du bilan",
        date: "20 Jan 2025",
        text:
          "Comprenez pourquoi l’intégration des critères ESG devient un impératif financier pour les entreprises et investisseurs visionnaires.",
      },
      {
        img: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=400",
        title: "Le capital-investissement à l’ère post-digitale",
        date: "20 Jan 2025",
        text:
          "Découvrez comment l’analytique avancée et la transformation digitale redéfinissent les opérations de private equity.",
      },
      {
        img: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=400",
        title: "Naviguer dans les réformes fiscales des marchés émergents",
        date: "20 Jan 2025",
        text:
          "Une analyse claire de l’impact des évolutions fiscales régionales sur les opérations et la conformité des entreprises internationales.",
      },
    ],
  };

  // ================= SELECT LANGUAGE =================
  const data = isFrench ? dataFR : dataEN;
  const { subtitle, heading, cards } = data;

  const [activeIndex, setActiveIndex] = useState(0);

  // Grouping cards per slide
  const chunkArray = (arr, size) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  };

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  const slides = chunkArray(cards, isMobile ? 1 : 3);

  return (
    <section className="section insight-resource-section">
      <div className="text-center mb-5">
        <div className="d-flex align-items-center justify-content-center mb-2">
          <div className="about-line me-3"></div>
          <p className="service-subtitle mb-0">{subtitle}</p>
        </div>

        <h2 className="client-heading">{heading}</h2>
      </div>

      {/* BOOTSTRAP CAROUSEL */}
      <Carousel
        indicators={false}
        controls={true}
        interval={3000}
        pause={false}
        activeIndex={activeIndex}
        onSelect={(i) => setActiveIndex(i)}
      >
        {slides.map((group, slideIndex) => (
          <Carousel.Item key={slideIndex}>
            <div
              className={`row g-4 ${
                group.length < 3 ? "justify-content-center" : ""
              }`}
            >
              {group.map((item, i) => (
                <div key={i} className="insight-card-main-div">
                  <div className="insight-card-box">
                    <div className="card-image-wrapper">
                      <img
                        className="card-main-img"
                        src={item.img}
                        alt={item.title}
                      />
                      <div className="date-badge-style">
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                          <line x1="16" y1="2" x2="16" y2="6" />
                          <line x1="8" y1="2" x2="8" y2="6" />
                          <line x1="3" y1="10" x2="21" y2="10" />
                        </svg>
                        <span>{item.date}</span>
                      </div>
                    </div>

                    <div className="insight-card-content">
                      <h5 className="insight-card-title">{item.title}</h5>
                      <p className="insight-card-text">{item.text}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Carousel.Item>
        ))}
      </Carousel>

      {/* CUSTOM INDICATORS */}
      <div className="custom-indicators">
        {slides.map((_, idx) => (
          <span
            key={idx}
            className={`indicator-left ${
              activeIndex === idx ? "active-indicator" : ""
            }`}
          ></span>
        ))}
      </div>
    </section>
  );
}
